import React from 'react';
import { motion } from 'framer-motion';
import Hastings from '../assets/images/HomePage/BrandSlider/Hastings.webp';
import Novax from '../assets/images/HomePage/BrandSlider/Novax.webp';
import Solucao from '../assets/images/HomePage/BrandSlider/Solucao.webp';
import SEW from '../assets/images/HomePage/BrandSlider/SEW.webp';
import UniT from '../assets/images/HomePage/BrandSlider/UniT.webp';
import Fussand from '../assets/images/HomePage/BrandSlider/Fussand.webp';
import EPI from '../assets/images/HomePage/BrandSlider/EPI.webp';
import Horn from '../assets/images/HomePage/BrandSlider/Horn.webp';
import Louisville from '../assets/images/HomePage/BrandSlider/Louisville.webp';
import Truper from '../assets/images/HomePage/BrandSlider/Truper.webp';
import KleinTools from '../assets/images/HomePage/BrandSlider/KleinTools.webp';

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const BrandSlider = () => {
  const brands = [
    { name: "Hastings", logo: Hastings },
    { name: "Novax", logo: Novax},
    { name: "Solucao", logo: Solucao },
    { name: "SEW", logo: SEW},
    { name: "Uni-T", logo: UniT },
    { name: "Fussand", logo: Fussand },
    { name: "KleinTools", logo: KleinTools },
    { name: "EPI", logo: EPI },
    { name: "Horn", logo: Horn },
    { name: "Truper", logo: Truper },
    { name: "Louisville", logo: Louisville }
  ];

  // Duplicamos las marcas para crear el efecto infinito
  const duplicatedBrands = [...brands, ...brands];

  return (
    <div className="bg-gradient-to-r from-blue-500 to-blue-800 text-white py-4 overflow-hidden border-y-2 border-transparent shadow-xl shadow-gray-700">
      <div className="flex items-center mb-2">
        <div className="container mx-auto px-4">
          <h3 className="text-sm font-bold text-center text-white">
            Partners Oficiales
          </h3>
        </div>
      </div>
      
      <motion.div
        className="flex items-center gap-12 whitespace-nowrap w-max"
        animate={{ x: ["-50%", "0%"] }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        {duplicatedBrands.map((brand, index) => (
          <motion.div
            key={`${brand.name}-${index}`}
            className="flex items-center gap-3 min-w-fit"
            whileHover={{ scale: 1.2 }}
            transition={{ duration: 0.2 }}
          >
            <div className="bg-white/10 backdrop-blur rounded-lg w-24 h-12 border border-white/20 hover:bg-white/20 transition-all flex items-center justify-center">
              <div className="flex items-center justify-center">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <div className="flex justify-center mt-2">
        <div className="flex items-center gap-2 text-white text-xs">
          <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
          <span>Distribuidores Autorizados</span>
          <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default BrandSlider;

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.